import React, { useEffect, useState, useContext, useCallback } from 'react';
import {
  Box,
  Drawer,
  Toolbar,
  Button,
  Divider,
  Select,
  MenuItem,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { SocketContext } from '../../contexts/socketContext';
import AuthContext from '../../contexts/authContext';

import {
  fetchOrgs,
  syncUser,
  getUser,
  logoutUser,
  patchUser,
} from '../../actions';

import iconUser from '../../res/images/icon_user.png';
import imgEvacuation from '../../res/images/evacuation.png';
import imgEvacuationOn from '../../res/images/evacuation_on.png';

import { user_types } from '../common/selectable_data';

const Item = (props) => {
  const { sx, ...other } = props;
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        // p: 1,
        m: 1,
        ...sx,
      }}
      {...other}
    />
  );
};

const drawerWidth = 240;

const Sidebar = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const socket = useContext(SocketContext);
  const authContext = useContext(AuthContext);

  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const [organization, setOrganization] = useState('');
  const organizations = useSelector((state) => state.org.organizations.rows);

  useEffect(() => {
    dispatch(fetchOrgs({}));
  }, [dispatch]);

  useEffect(() => {
    console.log('user', user);
    if (organizations && user && user.type === 3 && user.Organization) {
      setOrganization(user.Organization.id);
    }
  }, [dispatch, user, organizations]);

  const logoutHandler = () => {
    dispatch(logoutUser()).then(() => {
      authContext.logout();
    });
  };

  const handleDrawerToggle = () => {
    // console.log("drawer toggle");
    setMobileOpen(!mobileOpen);
  };

  const handleChangeOrganization = (e) => {
    e.preventDefault();
    setOrganization(e.target.value);
    const objUser = {
      OrganizationId: e.target.value,
    };
    dispatch(patchUser({ user: objUser, id: user.id }, navigate)).then(() => {
      dispatch(syncUser(user.id));
    });
  };

  const handleEmergency = useCallback(
    (event) => {
      event.preventDefault();

      if (window.confirm('긴급 상황 메시지를 전송하시겠습니까?')) {
        const { Organization } = user;
        socket.emit('emergency', {
          type: 1,
          OrganizationId: Organization.LoRaOrganizationId,
        });
      }
    },
    [socket, user]
  );

  const renderUserInfo = () => {
    if (!user || !organizations.length) return;
    console.log('user', user);
    console.log('oragnizations', organizations);
    return (
      <Box sx={{ mt: 3 }}>
        <Item>{user ? user.name : ''} 님, 환영합니다.</Item>
        <Item>{user_types.find((type) => type.id === user.type).name}</Item>
        {user.type === 3 && (
          <Item>
            <Select
              // label="건설사"
              value={organization}
              onChange={handleChangeOrganization}
            >
              {organizations.map((org) => (
                <MenuItem key={org.id} value={org.id}>
                  {org.displayName}
                </MenuItem>
              ))}
            </Select>
          </Item>
        )}
        {user.type !== 3 && <Item>{user.Organization.name}</Item>}
      </Box>
    );
  };

  const drawer = (
    <div>
      <Toolbar />
      {/* <Divider /> */}
      <Box sx={{ overflow: 'auto' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '30px' }}>
          <img src={iconUser} alt="" />
        </Box>
        {renderUserInfo()}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '30px' }}>
          <Button variant="contained" onClick={logoutHandler}>
            로그아웃
          </Button>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '30px' }}>
          <Link to="" onClick={handleEmergency}>
            <img src={imgEvacuation} alt="긴급대피" />
          </Link>
        </Box>
      </Box>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
    >
      <Drawer
        // container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
      <Divider />
    </Box>
  );
};

export default Sidebar;
